import createClient from 'openapi-fetch'
import type { paths } from './schema.js'
import { stringify } from '@/utils/querystring.js'
import { readCookie } from '@/utils/cookie.js'

export type Client = ReturnType<typeof createApiClient>

export function createApiClient(options: {
  baseUrl: string
  beforeRequest?: (input: RequestInfo | URL, init?: RequestInit) => void
  afterResponse?: (response: Response) => void
}) {
  const client = createClient<paths>({
    baseUrl: options.baseUrl,
    headers: {
      'Content-Type': 'application/vnd.api+json',
      get 'X-CSRFToken'() {
        return readCookie('csrftoken')
      },
    },
    credentials: 'include',
    querySerializer: stringify,
    async fetch(req) {
      options.beforeRequest?.(req.url, req)
      const response = await fetch(req)
      options.afterResponse?.(response)

      return response
    },
  })

  return client
}
